import { GlobalConstants } from './../../../pages/common/global-variables';
import { DataTransferService } from 'src/app/shared/services/common/datatransfer.service';
import { Subscription } from 'rxjs';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ApiService } from 'src/app/pages/common/api.service';
import { ToastrService } from 'ngx-toastr';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-card-switch',
  templateUrl: './card-switch.component.html',
  styleUrls: ['./card-switch.component.scss'],
  providers: [ApiService]
})
export class CardSwitchComponent implements OnInit, OnDestroy {
  userCards = [];
  selectedCardId;
  private subscriptions: Subscription[] = []
  constructor(
    public _apiService: ApiService,
    public _bsModalRef: BsModalRef,
    private toastr: ToastrService,
    private dataTransferService: DataTransferService,
    private GlobalConstants: GlobalConstants
  ) {
    this.getCards();
  }

  ngOnInit(): void {
    if (localStorage.getItem('uC')) {
      this.selectedCardId = JSON.parse(localStorage.getItem('uC')).id;
    }
  }

  getCards() {
    // var userCards = JSON.parse(localStorage.getItem("uCs"));
    this.dataTransferService.userCard$.subscribe(userCards => {
      if(userCards && userCards.length > 0){
        this.userCards = userCards;
      } else{
        const api = this.GlobalConstants.client === 'smeoffers' ? this._apiService.getCardsbyProject() : this._apiService.getCards();
        api.subscribe((res) => {
          if (res && res.data) {
            this.userCards = res.data;
            const userCards = res.data.map((card) => {
              const cardIdObj = {id: card.id};
              return cardIdObj
            })
            localStorage.setItem("uCs", JSON.stringify(userCards));
            this.dataTransferService.nextUserCards(res.data);
          }
        }, (err) => {
          this.toastr.error($localize`An error occured while fetching the cards! Please try again.`);
          setTimeout(()=>{
              this._bsModalRef.hide();
          }, 3000);
        })
      }
    })
  }

  setCard(each) {
    this._apiService.validateCard(each.attributes.bin, each.attributes.bin_type).subscribe(res => {
      if (res && res.data && res.data.attributes.bin == each.attributes.bin && res.data.attributes.status == 'bin_verified') {
        let current_user = JSON.parse(localStorage.getItem("currentUser"));
        // current_user.token = res.data.attributes.session_token;
        // localStorage.setItem('currentUser', JSON.stringify(current_user));
        localStorage.setItem('card_verified', "true");
        const cardObj = JSON.stringify({
          id: res.data.id, 
          attributes: {
            display_name: res.data.attributes.display_name
          }
        })
      localStorage.setItem('uC', cardObj);
      this.subscriptions.push(this.dataTransferService.userCard$.subscribe(response => {
        if(response && response.id == res.data.id){
          return
        } else {
          this.dataTransferService.nextUserCard(res.data);
        }
      }))
        window.location.href = "/";
      }
      else {
        localStorage.setItem('card_verified', "false");
      }
    })
  }

  ngOnDestroy(): void {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
  }
}
